<a
  [class]="'navigation-link column center cursor-pointer' + (active ? ' active-item' : '')"
  [routerLink]="link ? [link] : null"
  (click)="elementClicked()"
>
  <ion-icon
    [matTooltip]="mode === 'compact' ? text : ''"
    matTooltipPosition="after"
    *ngIf="!extra"
    name="{{ icon }}"
  ></ion-icon>
  <div *ngIf="mode === 'full'" class="item-text">{{ text | translate }}</div>
</a>
